<!--
 * @Version      : V1.0
 * @Date         : 2025-06-05 16:29:37
 * @fileName     : 合同执行情况
 * @Description  :
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="签约日期(年)" porp="signingDateYear">
            <el-date-picker clearable v-model="formInline.signingDateYear" format="yyyy 年" value-format="yyyy"
              type="year" placeholder="请选择签约日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同完成状态" porp="contractFinishStatus">
            <el-select clearable v-model="formInline.contractFinishStatus" filterable placeholder="请选择合同完成状态">
              <el-option label="未完成" value="0"></el-option>
              <el-option label="已完成" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款合同" porp="id">
            <el-select clearable v-model="queryForm.id" filterable placeholder="请选择收款合同">
              <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否归档" porp="ifArchive">
            <el-select clearable v-model="queryForm.ifArchive" filterable placeholder="请选择是否归档">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" porp="customerId">
            <el-select clearable filterable v-model="queryForm.customerId" placeholder="请选择客户">
              <el-option v-for="item in customerOption" :key="item.id" :label="item.customerName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="我方负责人" porp="ownerChargePersonId">
            <el-select clearable filterable v-model="queryForm.ownerChargePersonId" placeholder="请选择我方负责人">
              <el-option v-for="item in ownerChargePersonOption" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属楼盘" porp="buildingInformation">
            <el-input v-model="formInline.buildingInformation" placeholder="请输入所属楼盘"></el-input>
          </el-form-item>
          <el-form-item label="项目类型">
            <el-select clearable v-model="queryForm.projectTypeCode" placeholder="请选择项目类型" >
              <el-option v-for="item in projectOption" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="我方单位">
            <el-select clearable v-model="queryForm.ownerId" placeholder="请选择付款单位">
              <el-option v-for="item in ownerOption" :key="item.id" :label="item.unitName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
            <el-button type="success" @click="exportExcel()">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="operate py-20 border-box">
      <h4 class="operate-title">统计数据</h4>
      <div class="box-card-top" >
        <div class="box-card-sum" v-for="(item,index) in sumDataT" :key="index">
          <div class="sum-title">
            <span class="font-weight-bold font-small">{{item.label}}</span>
          </div>
          <div class="sum-bg">
            <el-statistic group-separator="," :precision="item.precision" :value="item.value" :value-style="{ fontSize: '25px', color: '#FFF' }"></el-statistic>
          </div>
        </div>
      </div>
      <div class="box-card-bottom">
        <div class="box-card-sum" v-for="(item,index) in sumDataB" :key="index">
          <div class="sum-title">
            <span class="font-weight-bold font-small">{{item.label}}</span>
          </div>
          <div class="sum-bg">
            <el-statistic group-separator="," :precision="item.precision" :value="item.value"
              :value-style="{ fontSize: '25px', color: '#FFF' }"></el-statistic>
          </div>
        </div>
      </div>
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
         <template #ifArchiveSlot="{ row }">
          <div>
            <el-tag :type="row.ifArchive==0?'danger':'success'" effect="dark">{{ row.ifArchive == 0 ? "否" : "是" }}</el-tag>
          </div>
        </template>
<!--<template #operate="{ row }">
          <div>
            <el-button type="text" @click="stopService(row)" v-if="row.ifStopService == 0">停止服务</el-button>
          </div>
        </template> -->
      </tableComponent>
    </div>

  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import { auditProcessStatus, formatterState } from '@/utils/index'
import { queryPageForExecuteApi, getExecuteStatisticsDataApi,exportForExecuteApi } from '@/api/contractExecutionStatus/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { querySupplierInfoListApi, queryChargeListtApi,queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { dataPage } from "@/api/sys/dictData";
import {downloadBlobFile}from '@/utils/common'
export default {
  components: {
    tableComponent,
  },
  data() {
    return {
      projectOption:[],
      ownerOption:[],
      loading: false,
      contractCount: 0,
      totalAmount: 0,
      detailsT: '',
      sumDataT:[
        {
          label:'执行合同总数',
          key:'contract_count',
          precision:0,
          value:0
        },
        {
          label:'执行合同总规模',
          key:'contract_amount',
          precision:0,
          value:0
        },
        {
          label:'已回款金额(元)',
          key:'received_amount',
          precision:2,
          value:0
        },
        {
          label:'未回款金额(元)',
          key:'no_received_amount',
          precision:2,
          value:0
        },
        {
          label:'总成本',
          key:'total_cost',
          precision:2,
          value:0
        },
        {
          label:'总利润',
          key:'total_profit',
          precision:2,
          value:0
        },
      ],
      sumDataB:[
        {
          label:'服务总客户数',
          key:'customer_count',
          precision:0,
          value:0
        },
        {
          label:'互联网服务类',
          key:'hlwfw_amount',
          precision:0,
          value:0
        },
        {
          label:'软件开发类',
          key:'rjkf_amount',
          precision:0,
          value:0
        },
        {
          label:'运营服务类',
          key:'yw_amount',
          precision:0,
          value:0
        },
        {
          label:'其他类',
          key:'qt_amount',
          precision:0,
          value:0
        },
      ],
      formInline: {
        signingDateYear: "",
        contractFinishStatus: "",
        buildingInformation:""
      },
      queryForm: {
        id: "",
        customerId: "",
        ownerChargePersonId: "",
        ifArchive: "",
        projectTypeCode:"",
        ownerId:""
      },
      receivableContractOption: [],
      customerOption: [],
      ownerChargePersonOption: [],
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "contractName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "客户联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "客户联系电话", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "110px",
          keyName: "customerContactPhone", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "我方单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "合同归档", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "60px",
          keyName: "ifArchive", // 数据的属性值
          align: "center",
          slotName: "ifArchiveSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "合同金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "已开票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "invoicedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "未开票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "noInvoicedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "已收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "receivedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "未收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "noReceivedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 113,
          title: "电费收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityCollectionAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 114,
          title: "电费付款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityPaymentAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "合同利润", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "profit", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "合同状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "contractFinishStatusLabel", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 20,
          title: "签约时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "signingDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 17,
          title: "合同开始时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "startDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 18,
          title: "合同结束时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "endDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 19,
          title: "合同期限(天)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractDuration", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.queryData()
    this.getLedgerContractList()
    this.getCurtomer()
    this.getChargeList()
    this.getOwnersList();
  },
  methods: {
    auditProcessStatus,
    formatterState,
    //查询
    queryData() {
      this.dictOption('project_type');
      this.initData()
      this.querySum()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            signingDateYear: "",
            contractFinishStatus: "",//合同完成状态 0 未完成 1已完成
            ...this.formInline
          },
          id: "",//合同id
          customerId: "",//客户ID
          ownerChargePersonId: "", //我方负责人id(经办人)
          ifArchive: "",//是否归档 1 是 0 否
          ...this.queryForm
        },
        ...item
      }
      this.loading = true;
      queryPageForExecuteApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.signingDateYear = "";
      this.formInline.contractFinishStatus = "";
      this.formInline.buildingInformation = "";
      this.queryForm.id = "";
      this.queryForm.ifArchive = "";
      this.queryForm.customerId = "";
      this.queryForm.ownerChargePersonId = "";
      this.queryForm.projectTypeCode = "";
      this.queryForm.ownerId = "";
      this.$nextTick(() => {
        this.initData()
        this.querySum()
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName: "",
        }
      }
      this.selectLoading = true;
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    //获取客户档案
    getCurtomer() {
      let params = {
        customerName: ""
      }
      querySupplierInfoListApi(params).then(res => {
        if (res.code == 200) {
          this.customerOption = res.data;
        }
      })
    },
    //我方负责人下拉
    getChargeList() {
      let params = {}
      queryChargeListtApi(params).then(res => {
        if (res.code == 200) {
          this.ownerChargePersonOption = res.data;
        }
      })
    },
    //获取执行统计数据
    querySum() {
      let params = {
        ...this.formInline,
        ...this.queryForm
      }
      getExecuteStatisticsDataApi(params).then(res => {
        if (res.code == 200) {
          for(let key in res.data){
            for(let i=0;i<this.sumDataT.length;i++){
              if(this.sumDataT[i].key==key){
                this.sumDataT[i].value = Number(res.data[key])
              }
            }
            for(let i=0;i<this.sumDataB.length;i++){
              if(this.sumDataB[i].key==key){
                this.sumDataB[i].value = Number(res.data[key])
              }
            }
          }
        }
      })
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.projectOption = res.data.rows || []
        }
      })
    },
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.ownerOption = res.data;
        }
      })
    },
    //导出
    exportExcel(){
      let params={
        ...this.formInline,
        ...this.queryForm
      }
      exportForExecuteApi(params).then(res=>{
        if(res){
          downloadBlobFile(res,'合同执行情况.xlsx');
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .box-card-top {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px 20px;
    grid-template-rows: 100px;

    .box-card-sum {
      background-color: #469a9a;
      height: 100%;
      border-radius: 5px;
      padding: 10px;
      box-sizing: border-box;

      .sum-title {
        color: #f7f4f4;
        font-size: 15px;
      }

      .sum-bg {
        padding-top: 20px;
        display: inline-block;
        box-sizing: border-box;
      }
    }
  }

  .box-card-bottom {
    margin-top: 20px;
    grid-template-columns: repeat(5, 1fr);
    @extend .box-card-top;

    .box-card-sum {
      @extend .box-card-sum;
      background-color: #f3a235;
    }
  }


  .operate {
    .operate-title{
      line-height: 40px;
    }
  }
}
</style>
